import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppoinmentHistoryAction } from "../../../redux/actions/AppoinmentAction";

export const HistoryPopup = ({ isHistoryPopup, setIsHistoryPopup }) => {
  const dispatch = useDispatch();

  const getAppoinmentHistory = useSelector(
    (state) => state?.AppoinmentReducer?.getAppoinmentHistory
  );

  useEffect(() => {
    dispatch(
      getAppoinmentHistoryAction(
        isHistoryPopup?.cardDetails?.appointmentId,
        isHistoryPopup?.cardDetails?.valueType
      )
    );
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between border-bottom modalHeader">
        <h4 className="font-bold text-black">History Log</h4>
        <button
          type="button"
          className="btn-close history-close"
          aria-label="Close"
          onClick={() => setIsHistoryPopup(null)}
        ></button>
      </div>
      <div className="modal-body">
        <div className="table-responsive __custom__properties">
          <table className="table">
            <thead>
              <tr>
                <th scope="col" style={{ minWidth: "100px" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ minWidth: "200px" }}>
                  Request Status
                </th>
                <th scope="col" style={{ minWidth: "300px" }}>
                  Updated By
                </th>
                <th scope="col" style={{ minWidth: "200px" }}>
                  Create Date & Time
                </th>
                <th scope="col">
                  Remarks
                </th>
                <th scope="col">
                Partial Test Not Done
                </th>
              </tr>
            </thead>
            <tbody>
              {getAppoinmentHistory?.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>
                      <span className="status-style">{ele?.statusName}</span>
                    </td>
                    <td>
                      <span>{ele?.createdBy}</span>
                    </td>
                    <td>{ele?.createdDateTime}</td>
                    <td>{ele?.remarks}</td>
                    <td>{ele?.partialTestNotDone}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
